module.exports = __webpack_public_path__ + "static/media/SWSCRC6-10.531a99a5.mp3";